import React, { useEffect, useState, Component } from 'react'
import { Link, useNavigate, Navigate } from 'react-router-dom'
import FormValidator from '../FormValidator';
import { withRouter } from '../withRouter';
import swal from 'sweetalert2';
//import logo from 'src/assets/images/avatars/Logo02.png';
import logo from 'src/assets/images/avatars/Logo-kalima.svg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'src/scss/input_css.scss'
import 'src/scss/new_design.scss'

window.Swal = swal;
class Login extends Component {

  constructor(props) {

    const resetPassword = sessionStorage.getItem('resetPassword');
    if (resetPassword) {
      Swal.fire('Sucess!', 'Your password successfully changed', 'success');
      sessionStorage.removeItem('resetPassword');
    }

    super(props);
    this.validator = new FormValidator([
      {
        field: 'email',
        method: 'isEmpty',
        validWhen: false,
        message: 'The Email field is required.'
      }, {
        field: 'password',
        method: 'isEmpty',
        validWhen: false,
        message: 'The Password field is required.'
      }
    ]);
    this.state = {
      email: '',
      password: '',
      data: [],
      validation: this.validator.valid(),
      buttonLoading:true,
    }

    this.submitted = false;
    this.isLoading = true;


    const registerUser = sessionStorage.getItem('user_register');

    if (registerUser == "true") {
      toast.success('Your registration form successfully submitted!', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      sessionStorage.setItem("user_register", false);
    }
  }
  handleChange = event => {
    event.preventDefault();
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleFormSubmit = async event => {
    this.isLoading = true;
    event.preventDefault();
    const validation = this.validator.validate(this.state);
    this.setState({
      validation
    });
    this.setState({
      buttonLoading: false,
    });  
    this.submitted = true;
    if (validation.isValid) {
      //reaches here if form validates successfully... 
      let email = this.state.email;
      let password = this.state.password;

      let result = await fetch(window.apiFetchBaseURL + 'auth/login', {
        method: 'post',
        body: JSON.stringify({
          email: email,
          password: password,
        }),
        headers: {
          "access-control-allow-origin": "*",
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        return response.json();
      }).catch(function (e) {
        alert("We are facing technical issue.");
      });

      if (result.status == true) {
        // sessionStorage.setItem('publisherUser', result.token);
        // sessionStorage.setItem("authenticated", true);
        localStorage.setItem('user', result.token);
        localStorage.setItem("authenticated", true);
        this.props.navigate('/dashboard');

      } else {
        alert(result.message);
      }
      this.isLoading = true;
      this.setState({
        buttonLoading: true,
      });  
    }else{
      this.setState({
        buttonLoading: true,
      }); 
    }
  }

  componentDidMount() { 
  
    setTimeout(() => {   
      
      let username = document.getElementById('Username').value;
      if(username == ""){
        document.getElementById('Username').value = ""; 
      }

      let password = document.getElementById('password').value;

      if(password == ""){
        document.getElementById('password').value = ""; 
      }
      
    }, 1000); 
  } 

  render() {

    let validation = this.submitted ? this.validator.validate(this.state) : this.state.validation;
    return (

      <div class="container" >  
        <ToastContainer /> 
        <div class="row d-flex justify-content-center">
          <div class="col-sm-4 col-lg-4 col-xl-4 col-xs-12 user_card" style={{ "margin-top": "69px" }}>
            <div className='row justify-content-center' style={{"margin-top": "35px"}}>
              <img src={logo} class="Logo" alt="Logo" />
            </div>
            <div class="d-flex justify-content-center form_container">
              <div className='col-12'>
                <form>
                  <div class="input-group mb-3" style={{ "margin-top": "30px" }}>
                    <div className="form-outline" style={{"border-radius":"50px"}}>
                      <input value={this.state.value} className={validation.email.message||this.state.email|| this.props.value ? "form-control active" : " form-control "} type="text" id="Username" name='email' autoComplete="off" onChange={this.handleChange} />
                      <label className={validation.email.message ? "form-label label-color" : " form-label"} htmlFor="Username" style={{ "marginLeft": "0px" }}>Email <span style={{ "color": "#c13818" }}>*</span></label>
                      <div className="form-notch" >
                        <div className={validation.email.message ? "form-notch-leading border-error-color" : "form-notch-leading"} style={{ "width": "9px" }}>    </div>
                        <div className={validation.email.message ? "form-notch-middle border-error-color-midd" : "form-notch-middle"} style={{ "width": "44.4px" }}></div>
                        <div className={validation.email.message ? "form-notch-trailing border-error-color" : "form-notch-trailing"} ></div>
                      </div>
                    </div>
                  </div>

                  <div class=" input-group mb-3" style={{ "margin-top": "40px" }}>
                    <div className="form-outline">
                      <input className={validation.password.message||this.state.password ? "form-control active" : " form-control"} autoComplete="false" type="password" id="password" name='password' onChange={this.handleChange} />                   

                      <label className={validation.password.message ? "form-label label-color" : " form-label"} htmlFor="password" style={{ "marginLeft": "0px" }}>Password <span style={{ "color": "#c13818" }}>*</span></label>
                      <div className="form-notch">
                        <div className={validation.password.message ? "form-notch-leading border-error-color" : "form-notch-leading"} style={{ "width": "9px" }}>    </div>
                        <div className={validation.password.message ? "form-notch-middle border-error-color-midd" : "form-notch-middle"} style={{ "width": "65.4px" }}></div>
                        <div className={validation.password.message ? "form-notch-trailing border-error-color" : "form-notch-trailing"} ></div>
                      </div>
                    </div>
                  </div>

                  <div class="input-group " style={{ "margin-top": "40px" }}>
                    <div class="col-6 custom-control custom-checkbox align-items-start">
                      <input type="checkbox" class="custom-control-input" id="customControlInline" />
                      <label class="custom-control-label DontHaveAnAccount" for="customControlInline">Keep me signed in</label>
                    </div>

                    <div class="col-6  align-items-end ForgotPassword" style={{ "text-align": "right" }}>
                      <Link className='ForgotPassword' to="/forgot-password">Forgot password?</Link>
                    </div>
                  </div>

                  <div style={{ "margin-top": "40px" }}>
                    <div class="d-flex justify-content-center DontHaveAnAccount">
                      Don't have an account?
                    </div>
                    <div class="d-flex justify-content-center ">
                      <Link to="/register" class="Create-an-Account">Create an Account</Link>
                    </div>
                  </div>
                  
                  <div className="Actions-2" style={{ "margin-top": "40px" }} onClick={this.handleFormSubmit}>

                  {this.state.buttonLoading ? (<div className="Web-Button">
                    <a style={{ "color": "white","cursor":"pointer" }} className='register-button' disabled >
                      Login
                    </a>
                    </div>):(
                    <div className="Web-Button">
                      <a style={{ "color": "white","pointerEvents": "none","opacity": "0.5" }} className='register-button' disabled >
                        <div class="spinner-border text-primary" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </a>
                    </div>
                  )}
                  </div>  
                  <br />  
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(Login)
